import type { InferOutput } from "valibot";

export const blogPostSchema = v.object({
  post_id: v.number(),
  permalink: v.pipe(v.string(), v.url()),
  title: v.string(),
  excerpt: v.string(),
  date_modified: v.string(),
  image_url: v.pipe(v.string(), v.url()),
});
export type BlogPost = InferOutput<typeof blogPostSchema>;

export const blogSchema = v.object({
  posts: v.array(blogPostSchema),
  posts_total: v.number(),
});
export type Blog = InferOutput<typeof blogSchema>;
